import businessmanWithDoubts from "../images/businessman-with-doubts.png"
import termAndCondition from "../images/term-and-condition.jpg"
import manWomanGirlBoy from "../images/man-woman-girl-boy.png"
import stressManagement from "../images/stress-management.png"
import coupleWithHeart from "../images/couple_with_heart.png"
import specialistBanner from "../images/specialist-banner1.png"
import findSpecialist1 from "../images/find-specialist-1.jpg"
import communityForums from "../images/community-forums.jpg"
import asideContactus from "../images/aside-contactus.webp"
import manRaisingHand from "../images/man-raising-hand.png"
import customWellness from "../images/custom-wellness.jpg"
import selfConfidence from "../images/self-confidence.png"
import thoughtBalloon from "../images/thought_balloon.png"
import groupWorkshop from "../images/group-workshop.jpg"
import privacyPolicy from "../images/privacy-policy.jpg"
import specalistCta from "../images/specalist-cta.jpg"
import dashboard from "../images/dashboard-banner.png"
import yogaPosition from "../images/yoga-position.png"
import testimonials from "../images/testimonials.jpg"
import brokenHeart from "../images/broken-heart.png"
import earthAfrica from "../images/earth_africa.png"
import getStarted1 from "../images/get-started1.jpg"
import notFound from "../images/something-lost.webp"
import videoCamera from "../images/video-camera.png"
import flexibility from "../images/flexibility.png"
import aboutNew from "../images/about-us-home.jpg"
import careerPath from "../images/career-path.png"
import noStopping from "../images/no-stopping.png"
import olderAdult from "../images/older_adult.png"
import ourMission from "../images/our-mission.jpg"
import cookieImg from "../images/cookie-img.webp"
import meditation from "../images/meditation.png"
import specialist from "../images/specialist.png"
import whiteLogo from "../images/white-logo.webp"
import earthAsia from "../images/earth_asia.png"
import stepIcon1 from "../images/step-icon1.png"
import stepIcon2 from "../images/step-icon2.png"
import stepIcon3 from "../images/step-icon3.png"
import stepIcon4 from "../images/step-icon4.png"
import slideImage1 from "../images/slide-1.webp"
import slideImage2 from "../images/slide-2.webp"
import slideImage3 from "../images/slide-3.webp"
import checkmark from "../images/checkmark.png"
import community from "../images/community.jpg"
import feedback2 from "../images/feedback2.png"
import mainLogo from "../images/main-logo.webp"
import oneOnOne from "../images/one-on-one.jpg"
import streaming from "../images/streaming.png"
import login from "../images/login-banner.png"
import mission1 from "../images/mission-1.jpg"
import mission2 from "../images/mission-2.jpg"
import exercise from "../images/exercise.png"
import resource from "../images/resource.png"
import unsplash from "../images/unsplash.jpg"
import homeCta from "../images/home-cta.jpg"
import balance from "../images/balance.png"
import contact from "../images/contact.jpg"
import deposit from "../images/deposit.png"
import sunrise from "../images/sunrise.png"
import talking from "../images/talking.png"
import weekend from "../images/weekend.png"
import about1 from "../images/about-1.png"
import about2 from "../images/about-2.png"
import about3 from "../images/about-3.png"
import flagIN from "../images/flag-in.png"
import coach2 from "../images/coach2.png"
import family from "../images/family.png"
import stress from "../images/stress.png"
import vision from "../images/vision.jpg"
import adult from "../images/adult.png"
import blogs from "../images/blogs.jpg"
import close from "../images/close.png"
import coach from "../images/coach.png"
import noti from "../images/noti.webp"
import chat from "../images/chat.png"
import faqs from "../images/faqs.jpg"
import flagES from "../images/es.png"
import flagUS from "../images/us.png"
import mind from "../images/mind.png"
import moon from "../images/moon.png"
import task from "../images/task.png"
import mic from "../images/mic.png"
import file from "../images/file.png"

const Images = {
  businessmanWithDoubts,
  stressManagement,
  termAndCondition,
  specialistBanner,
  coupleWithHeart,
  communityForums,
  findSpecialist1,
  manWomanGirlBoy,
  asideContactus,
  customWellness,
  manRaisingHand,
  selfConfidence,
  thoughtBalloon,
  groupWorkshop,
  privacyPolicy,
  specalistCta,
  testimonials,
  yogaPosition,
  brokenHeart,
  earthAfrica,
  flexibility,
  getStarted1,
  slideImage1,
  slideImage2,
  slideImage3,
  videoCamera,
  careerPath,
  meditation,
  noStopping,
  olderAdult,
  ourMission,
  specialist,
  checkmark,
  community,
  cookieImg,
  dashboard,
  earthAsia,
  feedback2,
  stepIcon1,
  stepIcon2,
  stepIcon3,
  stepIcon4,
  streaming,
  whiteLogo,
  aboutNew,
  exercise,
  mainLogo,
  mission1,
  mission2,
  notFound,
  oneOnOne,
  unsplash,
  resource,
  balance,
  contact,
  deposit,
  homeCta,
  sunrise,
  talking,
  weekend,
  about1,
  about2,
  about3,
  coach2,
  family,
  flagUS,
  flagES,
  flagIN,
  stress,
  vision,
  adult,
  blogs,
  close,
  coach,
  login,
  chat,
  faqs,
  mind,
  moon,
  noti,
  task,
  file,
  mic,
}

export default Images